import classNames from "classnames";
import type { ComponentPropsWithoutRef } from "react";
import { forwardRef } from "react";
import TextAreaAutosize from "react-textarea-autosize";

export const Input = forwardRef<
  HTMLTextAreaElement,
  ComponentPropsWithoutRef<typeof TextAreaAutosize>
>(({ className, ...passThroughProps }, ref) => (
  <TextAreaAutosize
    ref={ref}
    autoComplete="off"
    minRows={1}
    maxRows={3}
    className={classNames(
      "text-dark placeholder:text-default w-full resize-none border-0 bg-transparent p-0 leading-5 outline-none focus:ring-0",
      className,
    )}
    {...passThroughProps}
  />
));

Input.displayName = "Input";
